import React from 'react';
import AuthStore from '../stores/AuthStore';
import { RootStoreContext } from '../stores/RootStoreContext';

export const useAuthStore = (): AuthStore => {
    const store = React.useContext(RootStoreContext);
    if (!store) {
        throw new Error('useAuthStore must be used within a RootStoreProvider.');
    }
    return store.authStore;
};
